import script from "./ProjectClientsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectClientsView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectClientsView.vue?vue&type=style&index=0&id=9e015ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e015ea6"]])

export default __exports__